import { useState } from 'react';
import {useForm} from 'react-hook-form';
import { findUserPassword } from '../../../apis/user';
import {Button} from '../../../components/Button';
import {TextField} from '../../../components/TextField';
import {Icon} from '../../../components/Icon';
import { nToast } from '../../../plugins/reactToast';
import {useHistory} from "react-router";
import {useLocation} from "react-router-dom";

interface FormValues {
  userEmail?: string;
  password: string;
  confirmPassword: string;
  tokenVersionId: string;
}

const ChangePassword = () => {
  const { push } = useHistory();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const {
    register,
    formState,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<FormValues>({ mode: 'all' });
  const [successPopup, setSuccessPopup] = useState<boolean>(false);

  const _onSubmit = ({ password, confirmPassword }: FormValues) => {
    const tokenVersionId = query.get('tokenVersionId');
    if (password !== confirmPassword || !tokenVersionId) return;
    findUserPassword({newPassword: password, tokenVersionId: tokenVersionId})
        .then((response) => {
          if (response.data.code === 'SUCCESS') {
            setSuccessPopup(true);
          }
        })
        .catch((err) => {
          nToast(err.response.data.message);
        });
  };


  return (
    <div>
      {successPopup && (
          <>
            <div className="z-50 fixed inset-0 bg-littleblack flex items-center justify-center overflow-hidden">
              <div className="w-3/4 md:w-96 flex flex-col  bg-white overflow-hidden p-6 space-y-4">
                <div className="flex flex-row justify-between relative">
                  <div className="flex flex-col">
                    <p
                        key={`popup_title_cart`}
                        className="text-12 font-normal">
                      비밀번호 변경이 완료 되었습니다.
                    </p>
                  </div>
                  <button onClick={() => push('/')} className="flex space-x-2 w-4 absolute right-0 -top-1">
                    <Icon.X />
                  </button>
                </div>

                <p className="text-12 pb-6">로그인 하시겠습니까?</p>
                <div className="grid grid-cols-2 gap-4">
                  <Button
                      onClick={() => {
                        push('/login')
                      }}
                      text="로그인 하기"
                      className="text-10 font-light filled-gray-900 py-2"
                  />
                  <Button
                      onClick={() =>
                          push('/')
                      }
                      text="메인으로"
                      className="text-10 font-light border border-gray-400 px-5"
                  />
                </div>
              </div>
            </div>
          </>
      )}
      <form
        className="flex flex-col space-y-4 mt-8"
        onSubmit={handleSubmit(_onSubmit)}>
        <TextField
          type="password"
          label="신규 비밀번호"
          placeholder="새 비밀번호를 입력해주세요."
          valid={!errors.password?.message && !!watch().password}
          validText={'사용가능한 비밀번호 입니다.'}
          helper={errors.password?.message}
          defaultValue={''}
          {...register('password', {
            required: '비밀번호를 입력해주세요',
            validate: value => {
              if (value.length < 8) {
                return '최소 8자 이상 가능합니다';
              }
              if (value.length > 15) {
                return '최대 15자 까지만 가능합니다';
              }
            },
          })}
        />
        <TextField
          type="password"
          label="비밀번호 확인"
          placeholder="새 비밀번호를 다시 입력해주세요."
          valid={formState.isValid}
          validText={'비밀번호가 일치합니다.'}
          helper={errors.confirmPassword?.message}
          {...register('confirmPassword', {
            validate: value =>
              value === watch().password || '비밀번호가 일치하지 않습니다',
          })}
        />
        <Button
          disabled={
            !watch().password ||
            !watch().confirmPassword ||
            !formState.isValid ||
            !!errors.password?.message ||
            !!errors.confirmPassword?.message
          }
          type="submit"
          text="변경"
          className="filled-gray-900"
        />
      </form>
    </div>
  );
};

export default ChangePassword;
